import {
  ADD_AUTHOR,
  ADD_CATEGORY,
  ADD_SEARCH_ITEM,
  CLEAR_FILTER,
} from './actionType';

export const addSearchItem = (value) => {
  return {
    type: ADD_SEARCH_ITEM,
    payload: value,
  };
};

export const addCategory = (value) => {
  return {
    type: ADD_CATEGORY,
    payload: value,
  };
};
export const addAuthor = (value) => {
  return {
    type: ADD_AUTHOR,
    payload: value,
  };
};
export const clearFilter = () => {
  return {
    type: CLEAR_FILTER,
  };
};
